import LocalTime from "local-time"

LocalTime.start()
